module.exports = {
  title: 'EPC查询次数',
  route: {
    path: '/business-configure',
    children: {
      path: 'epc-query-frequency',
    },
  },
};
